/** Shared Tailwind / globals hook; safe to import outside `localFont()`. */
export const LATO_VARIABLE_CLASS = "font-lato-variable";
